module.exports = __webpack_public_path__ + "media/images/sort_desc-7c20275193c2f36352bede6ac03ba5d8.png";